// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b429d9b6","732":"a9a82472","977":"2a6816d7"}[chunkId] + ".chunk.js";
};